import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'


const styles = theme => ({
  column: {
    flexBasis: '33.33%',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px 0 0 ${theme.spacing.unit}px`
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  originalText: {
    marginTop: '24px'
  },
  padContainer: {
    '&:last-child': {
      paddingBottom: '2em'
    }
  }
})

const TranslationRow = ({ original, translation, index, sectionKey, onChange, classes }) => (
  <Grid container className={classes.padContainer}>
    <Grid item xs={12} sm={6}>
      <div className={classes.column}>
        <Typography className={classes.originalText}>
          {original}
        </Typography>
      </div>
    </Grid>
    <Grid item xs={12} sm={6}>
      <div className={classNames(classes.column, classes.helper)}>
        <TextField
          required
          error={translation.trim().length === 0}
          fullWidth
          multiline={true}
          value={translation}
          onChange={e => onChange(e, index)}
          name={sectionKey}
        />
      </div>
    </Grid>
  </Grid>
)


TranslationRow.propTypes = {
  original: PropTypes.string.isRequired,
  translation: PropTypes.string.isRequired,
  index: PropTypes.number,
  sectionKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(TranslationRow)


// WEBPACK FOOTER //
// ./src/components/counseling-session/translation/section/TranslationRow.js